import { Auditable, FeeType, ProcedureType, QueryParams, SortParams } from "..";

export interface StandardFee extends Auditable {
    tenantId: number;
    feeTypeId: number;
    procedureTypeId?: number;
    amount: number;

    feeType?: FeeType;
    procedureType?: ProcedureType;
}

export const DefaultStandardFeeQueryParams: QueryParams = {};

export const DefaultStandardFeeSortParams: SortParams = {
    orderBy: "feeTypeId",
    orderDesc: "false",
};
